import { Component, OnDestroy, OnInit } from '../../../../../core/decorators';

@Component({
    selector: 'filter-date',
    bindings: {
        filter: '=',
        model: '='
    },
    template: require('./filter-date.tpl.html')
})
export class FilterDateComponent implements OnInit, OnDestroy {
    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
